import React, { useState, useEffect } from 'react'
import step1 from '../Assets/images/step-1.png'
import step2 from '../Assets/images/step-2.png'
import step3 from '../Assets/images/step-3.png'
import step4 from '../Assets/images/step-4.png'
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import vikritinext from '../Assets/images/vikritinext.png'
import { useNavigate } from 'react-router-dom'
import showers from '../Assets/animations/prakriticonfetti.json'
import Lottie from 'lottie-react'
import { getUserDetails } from '../Auth/AuthUtil'
import useCartStore from '../DataRepo/CartStore'
import { profileModel } from '../Axios/AxiosConfig'
import Giftbox from '../Assets/animations/gift.json'

function PackageInfo() {

    const steps = [step1, step2, step3, step4]

    const userType = localStorage.getItem('userType')

    const { cartItems, updateQuantity, decreaseQuantity, isCartLoading, totalPrice, deliveryCharges, getCouponDetails, Coupons, CouponDetails, setCoupon, removeItem, getCart, clearCart, emptyCart, CouponErrorDetails, setCouponError,
        setCouponDetails, CompanyCodedetails, getCompanyCoupondetails } = useCartStore();

    const [isprofileloading, setprofileloading] = useState(true)
    const [showText, setShowText] = useState(false);
    const [ProfileData, setProfileData] = useState([])
    const navigate = useNavigate()

    const getProfile = async (id) => {
        try {
            let res = await profileModel.get(`/Profile/${id}`)
            if (res.status === 200) {
                const profile = res?.data
                setProfileData(profile)
                setprofileloading(false)
            }
        }
        catch (err) {
            console.log(err?.response?.data)
        }
    }

    const settings = {
        dots: true,
        speed: 500,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 2000,
        slidesToShow: 1,
        slidesToScroll: 1,
    };



    useEffect(() => {
        const userDetails = getUserDetails()
        getProfile(userDetails?.UID)
        getCompanyCoupondetails()
    }, [])

    console.log(CompanyCodedetails)

    return <div className='Welcome-page-section'>
        <div className='Wellness-categories-section'>

            <div className="Lottie-background">
                <Lottie animationData={showers} loop={false} />
            </div>

            <div className='wppackageinfocontainer'>
                <div>
                    <p className='text-center pkg-info-T'>
                        Congratulations!
                    </p>

                    <div className='giftbox-container flex justify-center items-center mt-5'>
                        {showText ? (
                            <div className="fade-in-text text-center"
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    gap: "5px"

                                }}>
                                {CompanyCodedetails ? (
                                    <>
                                        < p>Enjoy Your</p>
                                        {CompanyCodedetails && (
                                            <p style={{ color: "#DA6E0B", fontWeight: "700" }}>
                                                {CompanyCodedetails?.company_name}
                                            </p>
                                        )}
                                        <p>Wellness Gift</p>

                                    </>
                                ) : (
                                    <>
                                        <p>Enjoy Your</p>

                                        <p>Wellness Gift</p>
                                    </>
                                )}



                            </div>
                        ) : (
                            <Lottie animationData={Giftbox}
                                style={{ width: "100%", height: "100%" }}
                                onComplete={() => setShowText(true)}
                                loop={false}
                            />
                        )}
                    </div>
                </div>

                {/* <div className='Carosel-container'>
                    <Slider {...settings}>
                        {steps.map((step, index) => (
                            <div key={index} className='Carosel-item'>
                                <img
                                    src={step}
                                    alt={`Step ${index + 1}`}
                                    style={{
                                        // width: '100%',
                                        // height: '100%',
                                        // objectFit: 'cover',
                                        borderRadius: '10px',
                                    }}
                                />
                            </div>
                        ))}
                    </Slider>
                </div> */}

            </div>

            <div className='mt-5' onClick={() => {
                navigate('/profile')
            }}
                style={{ alignSelf: "center", justifySelf: "flex-end", marginTop: "auto", width: "3rem", cursor: "pointer" }} >
                <img src={vikritinext}></img>
            </div>

        </div>
    </div>
}

export default PackageInfo